import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgxEchartsModule } from 'ngx-echarts';
import { ColorPickerModule } from 'ngx-color-picker';
import { AsyncPipe, NgIf } from '@angular/common';
// import filepond module
import { FilePondModule } from 'ngx-filepond';
import { AppStateService } from './shared/services/app-state.service';
import { LoadingService } from './shared/services/loading.service';
@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [],
    imports: [FilePondModule, RouterOutlet, ToastrModule, NgxEchartsModule, ColorPickerModule, NgIf, AsyncPipe]
})
export class AppComponent {
  title = 'Livepass';
  loading$ = this.loadingService.loading$;

  constructor(private appState : AppStateService, private loadingService: LoadingService){
    this.appState.updateState();
  }
}
